import styled from 'styled-components';

const RequirementsList = styled.ul`
    list-style: disc;
    padding-left: 4rem;
`;

const Requirement = styled.li``;

export function PasswordRequirements() {
    /**
     * TODO: this will replace the requirements list used in ResetPassword.tsx once we update react-hook-form to >= 7.25.0,
     * and bring over the functionality used in the reset password component.
     * */

    return (
        <>
            <span>
                In order to protect your account, passwords must contain at least:
            </span>
            <RequirementsList>
                <Requirement aria-label="8 characters">8 characters</Requirement>
                <Requirement aria-label="an uppercase letter">
                    an uppercase letter
                </Requirement>
                <Requirement aria-label="a lowercase letter">
                    a lowercase letter
                </Requirement>
                <Requirement aria-label="a number">a number</Requirement>
                <Requirement aria-label="a special character">
                    a special character
                </Requirement>
            </RequirementsList>
        </>
    );
}
